<template>
  <div class="single-date-picker-container">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="formattedDate"
          :label="emptyText ?? Lang.date"
          append-icon="mdi-calendar"
          class="app-text-field"
          readonly
          v-bind="attrs"
          v-on="on"
          hide-details
          :error="hasError"
          :disabled="disabled"
        />
      </template>

      <div class="single-date-picker">
        <v-date-picker v-model="tempDate" @input="onDateSelected" no-title scrollable :min="min" :max="max" />
      </div>
    </v-menu>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { formatISODateLocal } from "@/helpers/formatters";
import Lang from "@/lang";

export default Vue.extend({
  name: "SingleDatePicker",
  props: {
    value: String,
    emptyText: {
      type: String,
      required: false,
      default: "Date",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    min: {
      type: String,
      required: false,
      default: "",
    },
    max: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      menu: false,
      selectedDate: this.value || "",
      tempDate: this.value || "",
      Lang,
    };
  },
  computed: {
    formattedDate(): string {
      return this.selectedDate ? formatISODateLocal(this.selectedDate).toString() : "";
    },
  },
  watch: {
    value(val: string) {
      this.selectedDate = val;
    },
  },
  methods: {
    onDateSelected(val: string) {
      this.selectedDate = val;
      this.$emit("input", this.selectedDate);
      this.menu = false;
    },
    onSave() {
      this.selectedDate = this.tempDate;
      this.$emit("input", this.selectedDate);
      this.menu = false;
    },
  },
});
</script>
<style lang="scss" scoped>
.single-date-picker-container {
  background-color: var(--v-background-dark-base);

  .v-text-field {
    background-color: transparent;
    color: var(--v-content-light-base);

    .v-label {
      color: var(--v-content-medium-base);
    }

    .v-input__control {
      min-height: 40px;
    }

    .v-input__slot input {
      color: var(--v-content-light-base);
      font-size: 14px;
      padding: 10px 0;
    }

    .v-input__prepend-outer .v-icon {
      color: var(--v-content-medium-base);
    }

    fieldset {
      border-color: transparent;
    }
  }
}

.single-date-picker {
  background: rgba(51, 54, 89, 1) !important;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);

  .v-date-picker-table {
    background-color: var(--v-background-dark-base);
  }

  .v-date-picker-title__year,
  .v-date-picker-title__date {
    color: var(--v-content-light-base);
  }

  .v-btn {
    color: var(--v-content-light-base);
  }

  .v-picker__body {
    background-color: var(--v-background-dark-base);
  }

  .v-picker__actions {
    background-color: var(--v-background-dark-base);
  }
}

.v-application.theme--dark {
  .single-date-picker-container {
    background: var(--v-primary-base);
  }

  .single-date-picker {
    background-color: var(--v-background-light-base);

    &__menu-item:hover {
      background-color: var(--v-medium-base);
    }
  }
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
  background-color: var(--v-accent-global-base) !important;
}
::v-deep .v-date-picker-header {
  background: #333659 !important;
  padding: 0;
}
::v-deep .v-date-picker-table {
  background: #333659 !important;
  padding: 0 !important;
}

::v-deep .v-picker.v-card.v-picker--date.theme--dark {
  width: 100%;
}

::v-deep .v-menu__content {
  border-radius: 24px !important;
}
</style>
